import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
} from '@angular/common/http';
import { Observable, timeout } from 'rxjs';
import { SKIP_TIMEOUT } from '../tokens/http-context.tokens';

@Injectable()
export class TimeoutInterceptor implements HttpInterceptor {
  private DEFAULT_TIMEOUT = 60000; // 30 seconds

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (req.context.get(SKIP_TIMEOUT)) {
      return next.handle(req);
    }

    return next.handle(req).pipe(timeout(this.DEFAULT_TIMEOUT));
  }
}
